import React from 'react';

const ActionContainer = ({ resetHandler }) => {
  return (
    <div className="text-right">
      <button
        type="reset"
        onClick={resetHandler}
        className="btnSizes transparentBtn border-0"
      >
        Reset Filter
      </button>
      <button
        type="submit"
        className="btnSizes filledBtn ml-5"
      >
        Search
      </button>
    </div>
  )
}

export default ActionContainer;